module.exports = __webpack_public_path__ + "static/media/gem5.9a1bab11.png";